import { render } from "./AppTitle.vue?vue&type=template&id=3b25e2f1&scoped=true"
const script = {}

import "./AppTitle.vue?vue&type=style&index=0&id=3b25e2f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b25e2f1"]])

export default __exports__